export function resolveFinancingPartner(application, financingPartner) {
  if (financingPartner) {
    return financingPartner;
  }

  if (!application?.financingPartner) {
    return null;
  }

  return Array.isArray(application.financingPartner)
    ? application.financingPartner[0]
    : application.financingPartner;
}

export function resolveContractBarcode(application, financingPartner) {
  const partner = resolveFinancingPartner(application, financingPartner);
  return partner?.barcode || null;
}
